import axios from 'axios'

document.addEventListener('turbo:load', async () => {
  const closeButton = document.getElementById('virtual-staging-save-button')
  if (closeButton) {
    const data = document.querySelector('#showcase.virtual-staging').dataset
    closeButton.addEventListener('click', async () => {
      const sceneData = await document.getElementById('dpm-virtual-staging-ui').__vue__.saveScene()
      const csrfHeader = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : ''
      }
      const res = await axios.patch(
        `${data.apiUrl}/save_scene`,
        { scene_data: sceneData },
        { headers: csrfHeader }
      )
      if (res.data.location) {
        window.location.href = res.data.location
      }
    })
  }
})
